module.exports = __webpack_public_path__ + "static/img/guanlian.1db734ec.png";